import LoginActivity from "../components/admin/LoginActivity";
import SuperAdminLayout from "../components/layout/SuperAdminLayout";

export default function SuperLogin() {
  return <LoginActivity Layout={SuperAdminLayout} canManage={true} />;
}
